import { Invoice } from '../types/invoice';

export type InvoiceUIState =
    | 'no-invoice'
    | 'processing'
    | 'certified'
    | 'cancelled'
    | 'rejected'
    | 'validation-error'
    | 'validation-error-with-details'
    | 'contact-support'
    | 'retry-after-midnight'
    | 'failed';

const getInvoiceUIState = (invoice: Invoice | null): InvoiceUIState => {
    if (!invoice) {
        return 'no-invoice';
    }

    switch (invoice.status) {
        case 'pending':
            return 'processing';

        case 'certified':
            return 'certified';

        case 'cancelled':
            return 'cancelled';

        case 'rejected':
            return 'rejected';

        case 'validationError':
            if (invoice.errorCode === 'satValidationError') {
                return 'validation-error-with-details';
            }
            if (invoice.errorCode === 'infileAuthError') {
                return 'contact-support';
            }
            return 'validation-error';

        case 'failed':
            if (invoice.errorCode === 'feelCredentialsError') {
                return 'contact-support';
            }
            if (invoice.errorCode === 'feelLimitExceeded') {
                return 'retry-after-midnight';
            }
            return 'failed';
    }
};

export default getInvoiceUIState;
